"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneNumberIsValid = exports.phoneStringToCountryCode = exports.phoneNumberToCountryCode = void 0;
var tslib_1 = require("tslib");
var awesome_phonenumber_1 = tslib_1.__importDefault(require("awesome-phonenumber"));
var phoneNumberToCountryCode = function (countryCode, phoneNumber) {
    return new awesome_phonenumber_1.default("+".concat(countryCode).concat(phoneNumber)).getRegionCode();
};
exports.phoneNumberToCountryCode = phoneNumberToCountryCode;
var phoneStringToCountryCode = function (phone) {
    var regionCode = new awesome_phonenumber_1.default(phone).getRegionCode();
    return "".concat(awesome_phonenumber_1.default.getCountryCodeForRegionCode(regionCode));
};
exports.phoneStringToCountryCode = phoneStringToCountryCode;
var phoneNumberIsValid = function (phoneNumber) {
    return new awesome_phonenumber_1.default("+".concat(phoneNumber.countryCode).concat(phoneNumber.number)).isValid();
};
exports.phoneNumberIsValid = phoneNumberIsValid;
//# sourceMappingURL=index.js.map